export default "__VITE_ASSET__pyHTbZe8__"